export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M12 2a9.96 9.96 0 0 1 6.35 2.274l-4.52 4.743a3.5 3.5 0 1 0 1.623 2.415l4.861-4.989A9.953 9.953 0 0 1 22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 1.5a8.5 8.5 0 1 0 7.927 5.432l-2.661 2.753a.74.74 0 0 1-.27.176c.001.046.004.093.004.139a5 5 0 1 1-3.512-4.775l2.602-2.677A8.46 8.46 0 0 0 12 3.5Z"/>
</svg>
`;
